<div class="mersy-landing-wrapper">
    <landing-page-grid 
        [items]="items" 
        [clusterIdentifier]="clusterIdentifier"
        [clusterName]="clusterName"
        [showBackground]="true">
    </landing-page-grid>
</div>